import { useEffect, useState } from "react";
import { useWallet } from "../context/WalletContext";
import { BuyTokenBonus, sendCoin } from "../utils/sendCoin";
import {
    HYPER_ADDRESS, NETWORKID_ACTIVE, NETWORKID_ACTIVE_DEC, SERVER_URL, STAGES_PRESALE, TOKENSALE_ADDRESS,
} from '../utils/constants';
import axios from "axios";
import { toast } from 'react-toastify';
import { fetchUserInfo } from "../api/user";
import { useUserStore } from "../stores/useUserStore";
import { addTokenToMetaMask, addBSCNetwork } from "../utils/metamaskHelper";
import { calculateStageProgress } from "../utils/presale";
import { switchNetwork } from "../utils/connectWallet";

const Presale = () => {
    const { account, networkId, isConnected, connectWallet, disconnectWallet } = useWallet();
    const [amount, setAmount] = useState("");
    const [token, setToken] = useState("");
    const [referral, setReferral] = useState("");
    const [isCorrectNetwork, setIsCorrectNetwork] = useState<boolean>(true);
    const [txHash, setTxHash] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [rate, setRate] = useState<number>(0);

    const [tokenSold, setTokenSold] = useState(0);
    const [progressList, setProgressList] = useState<number[]>([]);
    const myReferral = useUserStore((s) => s.referral);


    const setUser = useUserStore((s) => s.setUser);
    useEffect(() => {
        setIsCorrectNetwork(networkId == NETWORKID_ACTIVE || networkId == NETWORKID_ACTIVE_DEC);
    }, [networkId]);

    useEffect(()=>{
        const params = new URLSearchParams(window.location.search);
        const ref = params.get("ref");

        if (ref && myReferral?.toLowerCase() !== ref?.toLowerCase()) {
            setReferral(ref);
        }
    })


    // useEffect(() => {
    //     const loadProgress = async () => {
    //         const info = await getPresaleStage(networkId!);

    //     };
    //     loadProgress();
    // }, [isLoading]);

    useEffect(() => {
        const fetchRate = async () => {
            try {
                const res = await axios.get(`${SERVER_URL}/api/getInfoPresale`);
                setRate(res.data.presale_info.rate!);
                setTokenSold(res.data.presale_info.tokenSold);
                setProgressList(calculateStageProgress(res.data.presale_info.tokenSold));
            } catch (e) {
                console.log(e);
            }

        };

        fetchRate();

       
    }, [isLoading]);


    const handleSendBNB = async () => {

        if (!TOKENSALE_ADDRESS || !amount) {
            toast.error('amount is invalid')
            return;
        }
        try{
            Number(amount)
        }catch(e){
            toast.error('amount is invalid')
            return;
        }
     
        if(Number(amount) < 0.3){
            toast.error('Minimum Buy-in: 0.3 BNB')
            return;
        }
        setIsLoading(true);
        if (referral) {
            const referralOwner = await axios.get(`${SERVER_URL}/api/referrals?ref_id=${referral}`);

            if (!referralOwner.data.status) {
                setIsLoading(false);
                toast.error(referralOwner.data.message);
                return;
            }
            const hash = await BuyTokenBonus(TOKENSALE_ADDRESS, amount, referralOwner.data.address);
            if (hash) {
                try {
                    const res = await axios.post(`${SERVER_URL}/api/referrals`, {
                        frist_tx: hash,
                        address: account,
                        ref_id: referral
                    });

                    if (res.data) {
                        const user = await fetchUserInfo(account!);
                        if (!user)
                            return;
                        const res: any = await axios.post(`${SERVER_URL}/api/getBalanceAccount`, {
                            address: account
                        });
                        const data = res.data;

                        setUser({
                            account: user.address,
                            balance: Number(data.nativeBalance).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
                            token: Number(data.tokenBalance).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 }),

                            referral: user.ref_id,
                            rewards: user.rewards
                        });
                        toast.success(res.data.message);
                        setIsLoading(false);
                    }

                } catch (error) {
                    console.log(error)
                    toast.error('An error has occurred.');

                }
            }
            setIsLoading(false);

        } else {
            const hash = await sendCoin(TOKENSALE_ADDRESS, amount);
            if (hash) {
                try {
                    const res = await axios.post(`${SERVER_URL}/api/referrals`, {
                        frist_tx: hash,
                        address: account,
                        ref_id: referral
                    });

                    if (res.data) {
                        const user = await fetchUserInfo(account!);
                        if (!user)
                            return;
                        try {
                            const res: any = await axios.post(`${SERVER_URL}/api/getBalanceAccount`, {
                                address: account
                            });
                            const data = res.data;
                            setUser({
                                account: user.address,
                                balance: Number(data.nativeBalance).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
                                token: Number(data.tokenBalance).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 }),

                                referral: user.ref_id,
                                rewards: user.rewards
                            });
                            toast.success(res.data.message);
                            setIsLoading(false);
                        } catch (e: any) {
                            console.log(e.code)
                            toast.error('An error has occurred.')
                        }

                    }

                } catch (error) {
                    toast.error('An error has occurred.')
                    setIsLoading(false);
                }
            }
            setIsLoading(false);
        }


    };

    const caculatorGetToken = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        setAmount(inputValue);
        if (!isNaN(Number(inputValue)) || inputValue === "") {
            setToken((Number(inputValue) * rate).toLocaleString());
        } else {
            toast.error("Please enter a valid number!");
        }
    }

    return (
        <div id="presale" className="about-member-details">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title">
                            <h3
                                className="wow fadeInUp"
                                style={{ visibility: "visible", animationName: "fadeInUp" }}
                            >
                                Token Sale
                            </h3>
                            <h2 className="text-anime-style-2" data-cursor="-opaque">
                                <span>Public</span> Sale
                            </h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-7">
                        {/* Team Member Skills Bar Start */}
                        <div className="team-member-skills">
                            {/* Member Skills Title Start */}
                            <div className="member-skills-title">
                                <h6
                                    className="wow fadeInUp"
                                    style={{ visibility: "visible", animationName: "fadeInUp" }}
                                >
                                    Total Sale: 270,000,000 $HYPER
                                </h6>
                            </div>

                            {STAGES_PRESALE.map((stage, idx) => (
                                <div className="skills-progress-bar" key={idx}>
                                    <div className="skillbar" data-percent={`${progressList[idx] || 0}%`}>
                                        <div className="skill-data">
                                            <div className="skill-title">
                                                {stage.name} — {stage.total.toLocaleString()} $HYPER <br />
                                                (1 BNB = {stage.rate.toLocaleString()} $HYPER)                                        </div>
                                            <div className="skill-no">

                                                {Math.ceil(progressList[idx]).toLocaleString()}%
                                            </div>
                                        </div>
                                        <div className="skill-progress">
                                            <div
                                                className="count-bar"
                                                style={{
                                                    width: `${progressList[idx] || 0}%`,
                                                    background: "#76c7c0",
                                                    height: "10px",
                                                    borderRadius: "10px",
                                                    transition: "width 0.5s ease",
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="about-member-info">
                            <div className="member-info-title titleBuyToken">
                                <h6
                                    className="wow fadeInUp mg-b-10px"
                                    style={{ visibility: "visible", animationName: "fadeInUp" }}
                                >
                                    Minimum Buy-in: 0.3 BNB
                                </h6>
                            </div>
                            <br />
                            <div className="member-info-content">


                                <div className="row">
                                    <div className="col-lg-12">
                                        <div
                                            className="appointment-form wow fadeInUp"
                                            style={{ visibility: "visible", animationName: "fadeInUp" }}
                                        >

                                            <div className="row">
                                                <div className="form-group col-md-6 mb-4">
                                                    <b className="margin-bottom-5px">Pay Token (BNB)</b>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder="BNB"
                                                        value={amount}
                                                        onChange={(e) => caculatorGetToken(e)}
                                                        min={0.3}
                                                        max={100}
                                                        required
                                                    />
                                                    <div className="help-block with-errors" />
                                                </div>
                                                <div className="form-group col-md-6 mb-4">
                                                    <b className="margin-bottom-5px">Get Token (Hyper)</b>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Hyper"
                                                        value={token}
                                                        onChange={(e) => setToken(e.target.value)}
                                                        required
                                                        readOnly
                                                    />
                                                    <div className="help-block with-errors" />
                                                </div>
                                                <div className="form-group mb-4">
                                                    <b className="margin-bottom-5px">Referral (optional) </b>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Referral..."
                                                        value={referral}
                                                        onChange={(e) => setReferral(e.target.value)}

                                                    />
                                                    <div className="help-block with-errors" />
                                                </div>

                                                <div className="col-md-12 form-group">
                                                    {
                                                        isConnected ? (
                                                            isCorrectNetwork ? (<button className="btn-swap-token btn-w-100p" onClick={handleSendBNB} disabled={isLoading}>
                                                                <img src="images/crypto/networks/bsc.png" alt="Wallet Icon" className="btn-swap-token-icon" />
                                                                <span className="btn-swap-token-text">
                                                                    {isLoading ? (<><i className="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;
                                                                        Processing...
                                                                    </>) : 'Buy Now'}
                                                                </span>
                                                            </button>) : (
                                                                <button className="btn-swap-token btn-w-100p" onClick={() => switchNetwork()}>

                                                                    <img src="images/crypto/icons/warning.png" alt="Wallet Icon" className="btn-swap-token-icon" />
                                                                    <span className="btn-swap-token-text"> Wrong network</span>
                                                                </button>
                                                            )
                                                        ) : (
                                                            <button className="btn-swap-token btn-w-100p" onClick={connectWallet}>
                                                                <img src="images/crypto/networks/bsc.png" alt="Wallet Icon" className="btn-swap-token-icon" />
                                                                <span className="btn-swap-token-text"> Connect</span>
                                                            </button>
                                                        )
                                                    }

                                                </div>
                                            </div>

                                            <hr />
                                            <div className="d-flex">
                                                <button className="btn btn-sm btn-warning mr-3" onClick={addBSCNetwork}>
                                                    <img className="mr-3"
                                                        width="20px"
                                                        src="images/crypto/networks/metamask.png"
                                                    />
                                                    Add BSC Network
                                                </button>
                                                <button className="btn btn-sm  btn-success bg-color-primary" onClick={addTokenToMetaMask}>
                                                    <img className="mr-3"
                                                        width="20px"
                                                        src="images/crypto/networks/metamask.png"
                                                    />
                                                    Add $Hyper
                                                </button>
                                            </div>
                                            {/* Form End */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Presale;